var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838F",
  strokeWidth: 2,
  d: "M19.5 10c0 .841-.395 1.959-1.121 3.248-.711 1.263-1.672 2.575-2.653 3.776a51 51 0 0 1-3.226 3.572q-.235-.238-.53-.543a51 51 0 0 1-2.696-3.029c-.98-1.2-1.942-2.513-2.653-3.776C5.895 11.958 5.5 10.842 5.5 10a7 7 0 0 1 14 0Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 10,
  r: 2,
  stroke: "#77838F",
  strokeWidth: 2
})));
export default SvgLocationIcon;